module.exports = __webpack_public_path__ + "img/icon-search.3d2e837a.svg";